import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import messages from './messagesMakePayment';
import { limeGreen, red, orange } from '../../../colors';
import pendingIcon from '../../../images/pendingIcon.svg';
import {
	paymentMethodsTypes,
	paymentMethodsTypeVia,
} from '../../../constants/constants';

export const EXTERNAL_PAYMENT_STATUSES = {
	PENDING: 'PENDING',
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE',
};

export const isPciTelecomPayment = (attr) =>
	attr.method === paymentMethodsTypes.pciTelecom &&
	attr.via === paymentMethodsTypeVia.pciTelecom;

export const isKeyIvrPayment = (attr) =>
	attr.method === paymentMethodsTypes.keyIvr &&
	attr.via === paymentMethodsTypeVia.keyIvr;

const CustomPendingIcon = (props) => (
	<img src={pendingIcon} alt="pending" {...props} />
);

export const KEY_IVR_MODAL_CONFIG = {
	PENDING: {
		Icon: CustomPendingIcon,
		iconColor: orange,
		statusText: messages.lblKeyIvrPending,
		statusInBox: true,
		bodyText: messages.lblKeyIvrPendingText,
		showTopCallout: true,
		showBodyCallout: false,
		cancelDisabled: false,
		cancelColor: 'error',
		confirmDisabled: true,
		confirmBtnText: messages.btnKeyIvrCloseContinue,
		confirmColor: 'primary',
	},
	SUCCESS: {
		Icon: CheckCircleOutlineIcon,
		iconColor: limeGreen,
		statusText: messages.lblKeyIvrSuccess,
		statusInBox: true,
		bodyText: messages.lblKeyIvrSuccessText,
		showTopCallout: true,
		showBodyCallout: false,
		cancelDisabled: true,
		cancelColor: 'inherit',
		confirmDisabled: false,
		confirmBtnText: messages.btnKeyIvrCloseContinue,
		confirmColor: 'primary',
	},
	FAILURE: {
		Icon: CancelOutlinedIcon,
		iconColor: red,
		statusText: messages.lblKeyIvrFailure,
		statusInBox: false,
		bodyText: messages.lblKeyIvrFailureText,
		showTopCallout: false,
		showBodyCallout: true,
		cancelDisabled: true,
		cancelColor: 'inherit',
		confirmDisabled: false,
		confirmBtnText: messages.btnKeyIvrCloseWindow,
		confirmColor: 'primary',
	},
};

export const PCI_TELECOM_MODAL_CONFIG = {
	PENDING: {
		Icon: CustomPendingIcon,
		iconColor: orange,
		statusText: messages.lblPciTelecomPending,
		statusInBox: true,
		bodyText: messages.lblPciTelecomPendingText,
		showTopCallout: true,
		showBodyCallout: false,
		cancelDisabled: false,
		cancelColor: 'error',
		confirmDisabled: true,
		confirmBtnText: messages.btnPciTelecomCloseContinue,
		confirmColor: 'primary',
	},
	SUCCESS: {
		Icon: CheckCircleOutlineIcon,
		iconColor: limeGreen,
		statusText: messages.lblPciTelecomSuccess,
		statusInBox: true,
		bodyText: messages.lblPciTelecomSuccessText,
		showTopCallout: true,
		showBodyCallout: false,
		cancelDisabled: true,
		cancelColor: 'inherit',
		confirmDisabled: false,
		confirmBtnText: messages.btnPciTelecomCloseContinue,
		confirmColor: 'primary',
	},
	FAILURE: {
		Icon: CancelOutlinedIcon,
		iconColor: red,
		statusText: messages.lblPciTelecomFailure,
		statusInBox: false,
		bodyText: messages.lblPciTelecomFailureText,
		showTopCallout: false,
		showBodyCallout: true,
		cancelDisabled: true,
		cancelColor: 'inherit',
		confirmDisabled: false,
		confirmBtnText: messages.btnPciTelecomCloseWindow,
		confirmColor: 'primary',
	},
};
